import _ from 'classnames';
import React from 'react';
import styles from "./Circular.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function Circular({
  size = 'medium',
  className,
  centered,
  children
}) {
  const diameter = {
    small: 50,
    medium: 88,
    large: 140
  }[size];
  return /*#__PURE__*/_jsx("div", {
    style: {
      width: diameter,
      height: diameter,
      minWidth: diameter,
      minHeight: diameter
    },
    className: _(styles.circular, className, styles[size], {
      [styles.centered]: centered
    }),
    children: children
  });
}